module.exports = __webpack_public_path__ + "static/media/13-mobile.5e6162dc.jpg";